import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "en", name: "English", country_code: "us" },
  { code: "sq", name: "Shqip", country_code: "al" },
  { code: "it", name: "Italiano", country_code: "it" },
  { code: "de", name: "Deutsch", country_code: "de" },
  { code: "tr", name: "Türkçe", country_code: "tr" },
  { code: "ar", name: "العربية", country_code: "sa" },
];

export const LanguageSelector = ({ bgColor = "white" }) => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  useEffect(() => {
    document.body.dir = i18n.dir();
  }, [i18n.language]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Find the current language object
  const currentLanguage =
    languages.find((lng) => lng.code === i18n.language) || languages[0];

  return (
    <div ref={dropdownRef} className="relative rounded-xl min-w-[120px]">
      <button
        className={`flex min-w-[120px] items-center gap-2 border-none px-4 py-2 rounded-xl shadow-md bg-dry focus:outline-none`}
        onClick={() => setIsOpen(!isOpen)}
        style={{ backgroundColor: bgColor }}>
        <img
          src={`https://flagcdn.com/w40/${currentLanguage.country_code}.png`}
          alt={currentLanguage.name}
          className="w-5 h-5 rounded-full"
        />
        {currentLanguage.name || "Select Language"}
      </button>
      {isOpen && (
        <ul className="absolute mt-2 min-w-[120px] bg-white border border-gray-200 rounded-md shadow-lg z-50">
          {languages.map((lng) => (
            <li
              key={lng.code}
              className={`flex items-center gap-2 p-2 cursor-pointer hover:bg-gray-100 ${
                lng.code === i18n.language ? "bg-gray-200" : ""
              }`}
              onClick={() => changeLanguage(lng.code)}>
              <img
                src={`https://flagcdn.com/w40/${lng.country_code}.png`}
                alt={lng.name}
                className="w-5 h-5 rounded-full"
              />
              {lng.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSelector;
